import ActionableInput from 'pages/layouts/ActionableInput';
import Section from 'pages/layouts/Section';
import cx from 'classnames';

export const MailingListSubscribe = ({actionURL, caption, mediumWidth = false}) => {
  return (
    <Section bgColor="#4F6BEE">
      <div
        className={cx('flex grid grid-cols-1 items-center gap-4 text-white', {
          'lg:grid-cols-2': !mediumWidth,
        })}
        id="mailing-list-subscribe"
      >
        <div className={cx('text-3xl lg:pr-20', {'xl:text-5xl': !mediumWidth})}>{caption}</div>
        <div className={cx('mt-4', {'lg:mt-0': !mediumWidth})}>
          <ActionableInput
            placeholder="Enter your email"
            cta="Sign up"
            formId="newsletter-form"
            inputName="EMAIL"
            formActionTarget="_blank"
            formAction={actionURL}
            formActionMethod="POST"
          />
        </div>
      </div>
    </Section>
  );
};
